<script lang="ts">
	import GridLines from '$lib/components/GridLines.svelte';
	import GridContent from '$lib/components/GridContent.svelte';
	import GridInner from '$lib/components/GridInner.svelte';
	import { hatchStyle45 } from '$lib/styles/hatch';
</script>

<svelte:head>
	<title>Compliance - Corral AI</title>
</svelte:head>

<section
	class="bg-[#f9f9f4] py-24 relative min-h-[60vh]"
	style={hatchStyle45}
>
	<GridLines variant="light" />
	<GridContent>
		<GridInner>
			<div class="flex flex-col items-center text-center">
				<h1 class="font-display text-[48px] lg:text-[58px] text-black tracking-[-0.04em] leading-[1.1] mb-5">
					Compliance
				</h1>
			</div>

			<div class="mt-8 max-w-2xl mx-auto">
				<div class="bg-gray-50 border border-gray-200 rounded p-6 text-center">
					<p class="text-[15px] leading-relaxed text-[#333]">
						We are currently developing our auditing process and compliance framework to obtain our security certifications. Watch this page and our <a href="/news" class="text-[#0066cc] underline">blog</a> for updates on our compliance process as we progress through certification.
					</p>
				</div>
			</div>

			<!-- Legal Document Links -->
			<div class="mt-8 max-w-md mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
				<a
					href="/terms/privacy"
					class="bg-white border border-gray-200 rounded p-4 text-center hover:border-gray-400 transition-colors group"
				>
					<h3 class="font-mono font-medium text-[16px] text-black mb-1 group-hover:text-[#0066cc] transition-colors">
						Privacy Policy
					</h3>
					<p class="text-[13px] text-[#5c5855]">
						How we protect your data.
					</p>
				</a>
				<a
					href="/terms/tos"
					class="bg-white border border-gray-200 rounded p-4 text-center hover:border-gray-400 transition-colors group"
				>
					<h3 class="font-mono font-medium text-[16px] text-black mb-1 group-hover:text-[#0066cc] transition-colors">
						Terms of Service
					</h3>
					<p class="text-[13px] text-[#5c5855]">
						Platform terms and conditions.
					</p>
				</a>
			</div>
		</GridInner>
	</GridContent>
</section>
